<app-common-modal-wrapper
  icon=""
  [header]="contactModalHeader"
  [formGroup]="form"
  [isLoading]="isLoading()"
  (close)="close()"
  (submitModal)="submit()"
>
  <div class="d-flex flex-column gap-16">
    <app-input
      label="Email Address"
      formControlName="email"
      [customErrors]="emailValidatorMsg"
    />

    <app-input-phone-number
      formControlName="phone"
    />

    <app-checkbox
      formControlName="isPrimaryContact"
      label="Set as Primary Contact"
    />

    <app-divider/>

    <app-input
      label="Carbon Copy"
      formControlName="carbonCopy"
      placeholder="Optional"
      [customErrors]="emailValidatorMsg"
    />

    <app-input
      label="Blind Carbon Copy"
      formControlName="blindCarbonCopy"
      placeholder="Optional"
      [customErrors]="emailValidatorMsg"
    />

    <app-divider/>

    <app-select
      label="Type"
      formControlName="nicknameType"
      [options]="nicknameTypesOptions"
      [valuePrimitive]="true"
      [requireSorting]="false"
    />

    @if (form.controls.nicknameType.value == customNicknameOptionValue) {
      <app-input
        label="Add Custom Type"
        formControlName="nickname"
      />
    }

    @if (form.controls.email.touched && this.form.controls.phone.touched && form.errors) {
      <app-validation-error
        [control]="form"
        [customErrors]="contactFormCustomErrors"
      />
    }
  </div>

</app-common-modal-wrapper>
